import {
  PENGELOLAAN_KINERJA_GURU_PATH,
  PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH,
  PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
  PENGELOLAAN_KINERJA_PS_PATH,
} from 'app/KinerjaShared/constants/path'

import type { PelaksanaanState } from 'types/kinerja-ks-pelaksanaan'
import type { TStatePelaksanaan } from 'types/kinerja-pelaksanaan'

export const PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS: Record<
  TStatePelaksanaan,
  {
    order: number
    title?: string
    imagePath?: string
    path?: string
    resetMessage?: string
    resetMessageGuru?: string
  }
> = {
  DOCUMENT_PREPARATION: {
    order: 1,
    title: 'Dokumen Persiapan',
    imagePath: '/illustrations/img-document-penci-fill.png',
    path: `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-persiapan`,
    resetMessage: 'Isi dokumen akan dihapus.',
  },
  OBSERVATION_IMPLEMENTATION: {
    order: 2,
    title: 'Hasil Observasi Praktik Kinerja',
    imagePath: '/illustrations/img-observation-class-check.png',
    path: `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/pelaksanaan/dokumen-penilaian-observasi`,
    resetMessage: 'Rating sebelumnya akan dihapus.',
  },
  DOCUMENT_FOLLOW_UP: {
    order: 3,
    title: 'Penilaian Rencana Tindak Lanjut',
    imagePath: '/illustrations/img-document-interaction-discussion.png',
    path: `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
    resetMessageGuru: 'Isi dokumen akan dihapus.',
  },
  FOLLOW_UP_EVALUATION: {
    order: 4,
    title: 'Dokumen Penilaian Tindak Lanjut',
    imagePath: '/illustrations/img-document-interaction-discussion.png',
    path: `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/pelaksanaan/dokumen-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
  },
  DOCUMENT_REFLECTION_FOLLOW_UP: {
    order: 5,
    title: 'Penilaian Refleksi dan Evaluasi Tindak Lanjut',
    imagePath: '/illustrations/img-document-progress-bar-check.png',
    path: `${PENGELOLAAN_KINERJA_GURU_PATH}/pelaksanaan/dokumen-refleksi-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
    resetMessageGuru: 'Isi dokumen akan dihapus.',
  },
  REFLECTION_FOLLOW_UP_EVALUATION: {
    order: 6,
    title: 'Dokumen Penilaian Refleksi Tindak Lanjut',
    imagePath: '/illustrations/img-document-progress-bar-check.png',
    path: `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/pelaksanaan/dokumen-refleksi-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
  },
  COMPLETED: {
    order: 7,
  },
}

export const PENGELOLAAN_KINERJA_KS_PELAKSANAAN_STEPS: Record<
  PelaksanaanState,
  {
    order: number
    title?: string
    imagePath?: string
    path?: string
    resetMessage?: string
    resetMessageGuru?: string
  }
> = {
  PREPARATION: {
    order: 1,
    title: 'Dokumen Persiapan',
    imagePath: '/illustrations/img-document-penci-fill.png',
    path: `${PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH}/pelaksanaan/dokumen-persiapan`,
    resetMessage: 'Isi dokumen akan dihapus.',
  },
  OBSERVATION: {
    order: 2,
    title: 'Dokumen Rating Observasi',
    imagePath: '/illustrations/img-observation-class-check.png',
    path: `${PENGELOLAAN_KINERJA_PS_PATH}/pelaksanaan/dokumen-penilaian-observasi`,
    resetMessage: 'Rating sebelumnya akan dihapus.',
  },
  FOLLOW_UP: {
    order: 3,
    title: 'Dokumen Tindak Lanjut',
    imagePath: '/illustrations/img-document-interaction-discussion.png',
    path: `${PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH}/pelaksanaan/dokumen-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
    resetMessageGuru: 'Isi dokumen akan dihapus.',
  },
  FOLLOW_UP_EVALUATION: {
    order: 4,
    title: 'Dokumen Penilaian Tindak Lanjut',
    imagePath: '/illustrations/img-document-interaction-discussion.png',
    path: `${PENGELOLAAN_KINERJA_PS_PATH}/pelaksanaan/dokumen-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
  },
  REFLECTION_FOLLOW_UP: {
    order: 5,
    title: 'Dokumen Refleksi Tindak Lanjut',
    imagePath: '/illustrations/img-document-progress-bar-check.png',
    path: `${PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH}/pelaksanaan/dokumen-refleksi-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
    resetMessageGuru: 'Isi dokumen akan dihapus.',
  },
  REFLECTION_FOLLOW_UP_EVALUATION: {
    order: 6,
    title: 'Dokumen Penilaian Refleksi Tindak Lanjut',
    imagePath: '/illustrations/img-document-progress-bar-check.png',
    path: `${PENGELOLAAN_KINERJA_PS_PATH}/pelaksanaan/dokumen-refleksi-tindak-lanjut`,
    resetMessage: 'Nilai sebelumnya akan dihapus.',
  },
  COMPLETED: {
    order: 7,
  },
}
